export default function Stats() {
  const stats = [
    { number: '+30', label: 'Años de experiencia' },
    { number: '3', label: 'Abogados especializados' },
    { number: '+150', label: 'Servicios Jurídicos' },
    { number: '+16.000', label: 'Juicios Realizados' }
  ];

  return (
    <section className="py-16 bg-[#2C3E50]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-white text-center mb-12">
          Quereda y Murcia en cifras
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-[#A77047] mb-2">
                {stat.number}
              </div>
              <div className="text-white/80 text-sm">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}